<template>
  <div>
    <el-table
      class="table-normal animate__animated animate__fadeIn animate__slow"
      :data="dataAppeove"
      border
      style="width: 100%"
      v-loading="loading"
      element-loading-text="กำลังโหลดข้อมูล..."
      element-loading-spinner="el-icon-loading"
    >
      <template slot="empty">
        <p class="font-30 font-weight-500">ไม่พบข้อมูลที่คุณค้นหา</p>
      </template>
      <el-table-column prop="leadId" label="leadRefId" width="85px">
      </el-table-column>
      <el-table-column prop="customerId" label="custCode" width="85px">
      </el-table-column>
      <el-table-column
        prop="juristicId"
        label="juristicOrPersonId"
        width="150px"
      >
      </el-table-column>

      <el-table-column
        prop="customerNameTH"
        label="custNameTH"
        min-width="150px"
      >
      </el-table-column>
      <el-table-column
        prop="customerNameEN"
        label="custNameEN"
        min-width="150px"
      >
      </el-table-column>
      <el-table-column label="nplStatus" prop="debtorStatus" width="80px">
        <template slot-scope="scope">
          <span
            v-if="
              scope.row.debtorStatus == 'no' ||
              scope.row.debtorStatus == 'No' ||
              scope.row.debtorStatus == '0'
            "
            >0</span
          >
          <span
            v-else-if="
              scope.row.debtorStatus == 'yes' ||
              scope.row.debtorStatus == 'Yes' ||
              scope.row.debtorStatus == '1'
            "
            >1</span
          >
        </template>
      </el-table-column>
      <el-table-column label="hasLoanPerfStatus" width="138px">
        <template slot-scope="scope">
          <span
            v-if="
              scope.row.creditStatus == 'no' ||
              scope.row.creditStatus == 'No' ||
              scope.row.creditStatus == '0'
            "
            >0</span
          >
          <span
            v-else-if="
              scope.row.creditStatus == 'yes' ||
              scope.row.creditStatus == 'Yes' ||
              scope.row.creditStatus == '1'
            "
            >1</span
          >
        </template>
      </el-table-column>

      <el-table-column
        label="hasInsurePerfStatus"
        width="145px"
      >
        <template slot-scope="scope">
          <span
            v-if="
              scope.row.insuranceStatus == 'no' ||
              scope.row.insuranceStatus == 'No'
            "
            >0</span
          >
          <span
            v-else-if="
              scope.row.insuranceStatus == 'yes' ||
              scope.row.insuranceStatus == 'Yes'
            "
            >1</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="ratingYear" label="ratingYear" width="85px">
      </el-table-column>
      <el-table-column
        prop="creditRating"
        label="ratingComposite"
        width="125px"
      >
      </el-table-column>

      <el-table-column
        prop="eximCreditratingId"
        label="exim_creditratingId"
        min-width="150px"
      >
      </el-table-column>
      <el-table-column prop="custGuid" label="custGuid" min-width="150px">
      </el-table-column>
    </el-table>
    <div class="text-center mg-t-5">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="changePage"
        :current-page.sync="page"
        :page-sizes="[10, 30, 50, 100, 500]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNow"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataAppeove: {
      type: Array,
      default() {
        return [];
      },
    },

    loading: {
      type: Boolean,
      default() {
        return false;
      },
    },

    totalNow: {
      type: Number,
      default() {
        return 0;
      },
    },
    pageNow: {
      type: Number,
      default() {
        return 0;
      },
    },
    limit: {
      type: Number,
      default() {
        return 10;
      },
    },
  },
  data() {
    return {
      page: 0,
    };
  },
  mounted() {
    this.page = this.pageNow;
  },
  watch: {
    pageNow() {
      this.page = this.pageNow;
    },
  },
  methods: {
    changePage(page) {
      this.$emit("changePage", page);
    },
    handleSizeChange(page) {
      this.$emit("handleSizeChange", page);
    },
  },
};
</script>

<style></style>
